module.exports = __webpack_public_path__ + "img/COCHLEAR DAY.e46ca8c.svg";